import { useCallback } from 'react';
import styles from './PrimaryCTA.module.css';

/**
 * PrimaryCTA - Reusable primary action button component
 * @param {string} text - Button text to display
 * @param {function} onClick - Click handler function
 * @param {boolean} disabled - Whether button is disabled
 * @param {boolean} loading - Whether button is in loading state
 * @param {string} size - Button size: 'small', 'medium', 'large'
 * @param {string} className - Additional CSS classes
 */
const PrimaryCTA = ({
    text,
    onClick,
    disabled = false,
    loading = false,
    size = 'medium',
    className = ''
}) => {
    const handleClick = useCallback(() => {
        if (!disabled && !loading && onClick) {
            onClick();
        }
    }, [disabled, loading, onClick]);

    const buttonClasses = [
        styles.primaryCTA,
        styles[size],
        disabled ? styles.disabled : '',
        loading ? styles.loading : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            className={buttonClasses}
            onClick={handleClick}
            disabled={disabled || loading}
            type="button"
        >
            {loading ? (
                <span className={styles.loadingContent}>
                    <span className={styles.spinner}></span>
                    Loading...
                </span>
            ) : (
                text
            )}
        </button>
    );
};

export default PrimaryCTA;